import CustomPagination from "../CustomPagination/CustomPagination";

const CounterPagination = ({
  changePage,
  devices,
  counterTab,
  gasPage,
  powerPage,
  waterPage,
  count,
}) => {
  const waterMeters = devices.filter(
    (device) =>
      device?.water_meter_tag_info?.water_meter_tag_id ===
      "07d00e58-a3a4-4963-9f25-d22d4a5befbd"
  );
  const gasMeters = devices.filter(
    (device) =>
      device?.water_meter_tag_info?.water_meter_tag_id ===
      "3d5fd998-2637-4a61-a469-4bb344417cc5"
  );
  const powerMeters = devices.filter(
    (device) =>
      device?.water_meter_tag_info?.water_meter_tag_id ===
      "ac32c39a-c371-4936-a802-37ead17f8301"
  );
  const renderSelected = (tabValue) => {
    switch (tabValue) {
      case "0":
        return {
          page: waterPage.value,
          totalData: waterMeters.length,
          totalPages:
            waterMeters.length % count.value !== 0
              ? Math.floor(waterMeters.length / count.value) + 1
              : waterMeters.length / count.value,
        };
      case "1":
        return {
          page: powerPage.value,
          totalData: powerMeters.length,
          totalPages:
            powerMeters.length % count.value !== 0
              ? Math.floor(powerMeters.length / count.value) + 1
              : powerMeters.length / count.value,
        };
      case "2":
        return {
          page: gasPage.value,
          totalData: gasMeters.length,
          totalPages:
            gasMeters.length % count.value !== 0
              ? Math.floor(gasMeters.length / count.value) + 1
              : gasMeters.length / count.value,
        };
      default:
        return {
          page: waterPage.value,
          totalData: waterMeters.length,
          totalPages:
            waterMeters.length % count.value !== 0
              ? Math.floor(waterMeters.length / count.value) + 1
              : waterMeters.length / count.value,
        };
    }
  };
  return (
    <>
      <CustomPagination
        page={renderSelected(counterTab.value).page}
        totalPages={renderSelected(counterTab.value).totalPages}
        pageSize={count.value}
        totalData={renderSelected(counterTab.value).totalData}
        changePageFunc={changePage}
      />
    </>
  );
};
export default CounterPagination;
